import script from "./vipViewContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipViewContent.vue?vue&type=script&setup=true&lang=ts"

import "./vipViewContent.vue?vue&type=style&index=0&id=82e2dd7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82e2dd7a"]])

export default __exports__